/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_DimensionsInputs */

const en_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions`)
};

const ar_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأبعاد`)
};

const bn_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাপ`)
};

const de_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmessungen`)
};

const es_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiones`)
};

const fr_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions`)
};

const pt_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensões`)
};

const zh_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸`)
};

const tr_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boyutlar`)
};

const ru_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размеры`)
};

const pl_image_inspector_dimensions = /** @type {(inputs: Image_Inspector_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymiary`)
};

/**
* | output |
* | --- |
* | "Dimensions" |
*
* @param {Image_Inspector_DimensionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_dimensions = /** @type {((inputs?: Image_Inspector_DimensionsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_DimensionsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_dimensions(inputs)
	if (locale === "bn") return bn_image_inspector_dimensions(inputs)
	if (locale === "de") return de_image_inspector_dimensions(inputs)
	if (locale === "es") return es_image_inspector_dimensions(inputs)
	if (locale === "fr") return fr_image_inspector_dimensions(inputs)
	if (locale === "pt") return pt_image_inspector_dimensions(inputs)
	if (locale === "zh") return zh_image_inspector_dimensions(inputs)
	if (locale === "tr") return tr_image_inspector_dimensions(inputs)
	if (locale === "ru") return ru_image_inspector_dimensions(inputs)
	if (locale === "pl") return pl_image_inspector_dimensions(inputs)
	return en_image_inspector_dimensions(inputs)
});